import React, { createContext, useContext, useEffect, useState } from "react";

const BookingContext = createContext(null);

const todayPlus = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};
const today = () => todayPlus(0);
const isPast = (iso) => iso && iso < today();

const initial = {
  pickupLocation: "Santo Domingo",
  dropoffLocation: "Santo Domingo",
  pickupDate: today(),
  dropoffDate: todayPlus(3),
  sameLocation: true,
  carId: null,
  driver: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    license: "",
    country: "Dominican Republic",
    birthDate: "",
    address: "",
    city: "",
    zip: "",
    flightNo: "",
  },
  payment: {
    method: "stripe",
    cardNumber: "",
    cardName: "",
    expiry: "",
    cvc: "",
  },
};

export function BookingProvider({ children }) {
  const [state, setState] = useState(() => {
    try {
      const saved = localStorage.getItem("dams_booking");
      const merged = saved ? { ...initial, ...JSON.parse(saved) } : initial;
      // Auto-correct stale dates: if the persisted pickup is in the past,
      // bump pickup to today and shift drop-off forward by the original
      // duration (clamped to at least today+1).
      if (isPast(merged.pickupDate)) {
        const oldStart = new Date(merged.pickupDate);
        const oldEnd = new Date(merged.dropoffDate);
        const durationDays = Math.max(1, Math.round((oldEnd - oldStart) / 86400000) || 1);
        merged.pickupDate = today();
        merged.dropoffDate = todayPlus(durationDays);
      } else if (isPast(merged.dropoffDate)) {
        merged.dropoffDate = todayPlus(1);
      }
      return merged;
    } catch (e) {
      return initial;
    }
  });

  useEffect(() => {
    localStorage.setItem("dams_booking", JSON.stringify(state));
  }, [state]);

  const update = (patch) => setState((s) => ({ ...s, ...patch }));
  const updateDriver = (patch) =>
    setState((s) => ({ ...s, driver: { ...s.driver, ...patch } }));
  const updatePayment = (patch) =>
    setState((s) => ({ ...s, payment: { ...s.payment, ...patch } }));
  const reset = () => setState(initial);

  const daysBetween = (() => {
    const a = new Date(state.pickupDate);
    const b = new Date(state.dropoffDate);
    const diff = Math.round((b - a) / 86400000);
    return Math.max(1, diff || 1);
  })();

  return (
    <BookingContext.Provider
      value={{ ...state, update, updateDriver, updatePayment, reset, days: daysBetween, today: today() }}
    >
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => useContext(BookingContext);
